import axios from 'axios';

export const getValidatePostcode = (postcode, onSuccess, onFailure) => {
  axios({
    method: 'get',
    url: '/postcodes/check.json',
    params: {
      postcode: postcode,
    },
    responseType:'json'
  })
  .then((response) => {
    onSuccess(response)
  }).catch((error) => {
    onFailure(error)
  });
}

